import React, { use, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import btn from "./../../../assets/imgs/Assetbtn.svg";
import logo from "./../../../assets/imgs/logo2.32a2f0e40fc629cb6e51.png";
import AsiacellService from "./../../../Utilies/Utilies/AsiacellService"; 
import { useTranslation } from "react-i18next";
import Layout from "../../../Components/layout.jsx";
import { gtagReportConversion } from "../../../Utilies/Utilies/helper.js";
function AciqVerify() {
  const [errMsg, setErrMsg] = useState("");
  const location = useLocation();
 const [AntiFrauduniqid, setAntiFrauduniqid] = useState("");
  const [mcpuniqid, setMcpuniqid] = useState("");
  const [otp, setOtp] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [showError, setShowError] = useState(false);
      const [showLoading, setShowLoading] = useState(false);
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  useEffect(() => {
    document.body.dir = i18n.dir();
  }, [i18n, i18n.language]);
 
  useEffect(() => {
    fetchHeader();

  }, []);
const fetchHeader = async () => {
  try {
    const data = await AsiacellService.getPhoneByHeader();
      doHeaderSignup(data);
  } catch {
  }
};

  const doHeaderSignup = async (header) => {
    const body = {
      headers: header.Headers,
      msisdn:localStorage.getItem("msisdn"),
      pageid: "2",
    };

    try {
      const res = await AsiacellService.getScript(body);
      if (res && res.data) {
        const script = document.createElement("script");
        script.innerHTML = res.data.message;
        document.head.appendChild(script);
        setAntiFrauduniqid(res.data.AntiFrauduniqid);
        setShowLoading(false);
      } else {
        setShowError(true);
        setErrorMessage(res.message);
      }
    } catch (err) {
      setShowError(true);
    }
  };
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 4);
    setOtp(value);
    if (errMsg) setErrMsg("");
  };

 const verifyPincode = async () => {
  if (otp.length !== 4) return;

  const phoneNum = localStorage.getItem("msisdn");
  const params = {
    phone: phoneNum,
    otp: otp,
    AntiFrauduniqid:AntiFrauduniqid || null,
     company: localStorage.getItem("trafficsource") || null,
    key: localStorage.getItem("parameter") || null,
  
  };
  try {
    const response = await AsiacellService.verifyNonheader(params);

    if (response.success === true) {
      localStorage.setItem("phone", phoneNum);
     // gtagReportConversion();
      navigate("/success");
    } else {
      setErrMsg(response.message);
    }

  } catch (error) {
    setErrMsg(error?.response?.data?.message || "خطأ في التحقق");
  }
};


  return (
    <>
      <Layout reloadOnLanguageChange>
        <img className="servImg" src={logo} alt="" />

        {/* <h4>{t("SubscribeNowText")}</h4> */}

        <div className="mb-3">
          <label htmlFor="exampleFormControlInput1" className="form-label">
            {t("Enterpincode")}
          </label>
          <input
            type="text"
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={4}
            className="form-control text-center"
            id="exampleFormControlInput1"
            placeholder="xxxx"
            value={otp}
            onChange={handleOtpChange}
          />
          {errMsg ? (
            <p className="w-100 overflow-hidden bg-danger-subtle rounded text-danger p-2 mt-3">
              {errMsg}
            </p>
          ) : (
            ""
          )}
          <button
          id="btn-sub"
            className="btn btn-sub"
            disabled={otp.length !== 4 || showLoading}
            onClick={verifyPincode}
          >
            <img className={"btn-bg"} src={btn} alt="" />
            <h3 className="btn-txt">{t("confirm_subscribe")}</h3>
          </button>
        </div>

      </Layout>
    </>
  );
}

export default AciqVerify;
